import React, { Component } from "react";
import { Link } from "react-router-dom";
import Select from "./select";

class ModuleFiltersAdvanced extends Component {
  state = {
    statusOptions: [],
  };

  componentDidMount() {
    this.setState({ statusOptions: [] });
    if (this.props.module === "projects") {
      this.setState({
        statusOptions: [
          { id: 1, name: "Active" },
          { id: 2, name: "Completed" },
          { id: 0, name: "Stopped" },
        ],
      });
    } else if (this.props.module === "received") {
      this.setState({
        statusOptions: [
          { id: 1, name: "Received" },
          { id: 0, name: "Cleared" },
        ],
      });
    } else if (this.props.module === "issued") {
      this.setState({
        statusOptions: [
          { id: 1, name: "Paid" },
          { id: 0, name: "Pending" },
        ],
      });
    } else {
      this.setState({
        statusOptions: [
          { id: 1, name: "Active" },
          { id: 0, name: "InActive" },
          { id: 2, name: "Zero" },
        ],
      });
    }
  }

  render() {
    const {
      onSearchButtonClick,
      addLink,
      addTitle,
      keyword,
      onInputChange,
      status,
      onReset,
      onSelectChange,
    } = this.props;

    return (
      <React.Fragment>
        <input
          id="keyword"
          className="input"
          value={keyword}
          placeholder="Search by keyword"
          onChange={onInputChange}
        />
        <Select
          name="status"
          status={status}
          options={this.state.statusOptions}
          onChange={onSelectChange}
        />
        {/* <button
          onClick={() => onSearchButtonClick(keyword, status)}
          id="searcBtn"
          className="btn btn--primary"
          type="button"
        >
          Search
        </button> */}

        <button onClick={onReset} className="btn btn--secondary" type="button">
          Reset
        </button>
        <div className="filters_spacer"></div>
        <Link to={addLink} className="btn btn--accent" style={{ margin: 0 }}>
          + {addTitle}
        </Link>
      </React.Fragment>
    );
  }
}

export default ModuleFiltersAdvanced;
